import {Reducer} from "redux";
import {fromJS} from "immutable";
import {singlePointLayer} from "./loadMapStyle";
import {getEmptyData} from "../../utils/emptyData";
import {IApplicationState} from "../types";
import {createPointSourceFeature} from "../../utils/createPointSourceFeature";

const layerKey = singlePointLayer.source;

const reducer: Reducer<IApplicationState['map']> = (state, action) => {
    let { feature = getEmptyData() } = action.payload;
    let mapStyle = state?.mapStyle;
    const source = fromJS(feature);
    mapStyle = mapStyle?.setIn(['sources', layerKey], source);

    // Add point layer to map
    return {...state, mapStyle} as IApplicationState['map'];
};

export { reducer as setSinglePoint };
